import { render } from "./ShoppingCar.vue?vue&type=template&id=40942ff0&scoped=true"
import script from "./ShoppingCar.vue?vue&type=script&lang=js"
export * from "./ShoppingCar.vue?vue&type=script&lang=js"

import "./ShoppingCar.vue?vue&type=style&index=0&id=40942ff0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40942ff0"]])

export default __exports__